import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers"
import CategoryHero from "../ones/CategoryHero"
import Footer from "../ones/Footer"
import AccountDashboard from "./AccountDashboard"
import AccountLogin from "./AccountLogin"

export default function AccountLanding() {

  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await appContext.authCheck().then(async (_auth) => {
      if (_auth) {
        await appContext.getCurrentUserData();
      }
    })
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [])

  if (ready) {
    return (
      <>
        <CategoryHero
          eyebrow="YOUR ACCOUNT"
          title={appContext.auth ? "Welcome to your Mika Kenyata account." : "Sign in to build your personal library."}
          description={appContext.auth ?
            "Manage your profile and find all your purchased content from one dashboard."
            :
            "Sign in with your phone number or create an account through secure OTP verification."
          }
        />

        <div className="container marketplace-page-container">
          {appContext.auth ? <AccountDashboard /> : <AccountLogin />}
        </div>

        <Footer />
      </>
    )
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
